import { GQLSplitCta2Fragment } from '@theprintbar/graphql';
import { cn } from '@theprintbar/shared';
import { BrandStar, ButtonSize, OutlineLinkButton, SmallArrowIcon } from '@theprintbar/ui';
import { CTAContainer } from './CTAContainer';
import { CTAText } from './CTAText';

interface CTAProps2 {
	content?: Pick<GQLSplitCta2Fragment, 'splitCTAs2'>;
}

export function SplitCTA2({ content }: CTAProps2) {
	if (!content?.splitCTAs2?.structure) return null;

	return (
		<CTAContainer className="py-0">
			<div className="grid grid-cols-1 lg:grid-cols-2 gap-7">
				{content.splitCTAs2.structure.map((cta, i) =>
					cta ? (
						<div key={`${cta.title}-${i}`} className="relative rounded-3xl border border-blue p-10 lg:px-12 lg:py-16">
							{/* Content */}
							<div className={cn('space-y-10')}>
								<div className="flex items-center justify-between">
									{/* Title */}
									<h2 className="font-display text-2xl font-light lg:text-3xl">{cta.title}</h2>
									{/* Icon for Desktop */}
									{cta.icon ? (
										<img
											loading="lazy"
											src={cta.icon.image.url}
											alt={cta.icon.altText || 'icon'}
											className="hidden lg:block w-10 h-10"
										/>
									) : (
										<BrandStar className="hidden lg:block w-10 h-10 fill-blue" />
									)}
								</div>
								{/* Text */}
								<CTAText className="lg:text-base text-sm 2xl:pr-36" text={cta.text} />
								<div className="flex items-center justify-between lg:flex-none">
									{/* CTAs */}
									{cta.link ? (
										<OutlineLinkButton
											className="w-fit uppercase text-xs"
											to={cta.link.to || '#'}
											icon={SmallArrowIcon}
											iconSize={ButtonSize.S}
										>
											<h5>{cta.link.text}</h5>
										</OutlineLinkButton>
									) : null}
									{/* Icon for Desktop */}
									{cta.icon ? (
										<img
											loading="lazy"
											src={cta.icon.image.url}
											alt={cta.icon.altText || 'icon'}
											className="lg:hidden w-6 h-6"
										/>
									) : (
										<BrandStar className="lg:hidden w-6 h-6 fill-blue" />
									)}
								</div>
							</div>
						</div>
					) : null,
				)}
			</div>
		</CTAContainer>
	);
}
